import {
  ArrowsRightLeftIcon,
  BuildingOffice2Icon,
  UserGroupIcon
} from '@heroicons/react/24/outline';
import type { ProUpgradeUseCase } from '~/components/pro-upgrade-dialog';

export const INTEGRATIONS_PRO_UPGRADE_USE_CASES: ProUpgradeUseCase[] = [
  {
    id: 'ams_book_of_business',
    title: 'Your book of business',
    description: 'Connect your AMS to pull clients, policies, and account details into Cara.',
    icon: (
      <div className="inline-flex rounded bg-blue-100 dark:bg-blue-500/20 p-2 text-blue-700 dark:text-blue-300">
        <BuildingOffice2Icon className="size-4" />
      </div>
    )
  },
  {
    id: 'crm_service_context',
    title: 'CRM alongside the policy',
    description:
      'Link your CRM so Cara can see contacts, open tickets, and recent correspondence when handling service work.',
    icon: (
      <div className="inline-flex rounded bg-purple-100 dark:bg-purple-500/20 p-2 text-purple-700 dark:text-purple-300">
        <UserGroupIcon className="size-4" />
      </div>
    )
  },
  {
    id: 'write_back',
    title: 'Write back where your team works',
    description:
      'Log activity and updates to your AMS or CRM from Cara so producers and CSRs stay in the systems they already use.',
    icon: (
      <div className="inline-flex rounded bg-sky-100 dark:bg-sky-500/20 p-2 text-sky-700 dark:text-sky-300">
        <ArrowsRightLeftIcon className="size-4" />
      </div>
    )
  }
];
